import { useState, useEffect } from 'react';
import { useLocation, Link, useNavigate } from 'react-router-dom';

// ** MUI Components
import { Typography, Box, CardContent } from '@mui/material';
import AuthIllustrationV1Wrapper from '../login/AuthIllustrationV1Wrapper.js';
import BlankLayout from '../../Layout/blankLayout.js';
import { dev_baseUrl } from "../../../utils/var.js";
import MuiCard from '@mui/material/Card'
import { styled } from '@mui/material/styles'

const linkStyles = {
  textDecoration: 'none',
  color: '#007AFF',
  fontWeight: 500,
  fontSize: '14px',
  px: 1,
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
  }
};

const VerifyEmail = () => {
  const location = useLocation();
  const { email, firstName, lastName, password } = location.state || {};

  const [message, setMessage] = useState(null);
  const [disableResend, setDisableResend] = useState(false);
  const [countdown, setCountdown] = useState(15);

  const navigate = useNavigate();

  useEffect(() => {
    let timer;

    if (disableResend) {
     
      timer = setInterval(() => {
        setCountdown(prevCount => {
          if (prevCount <= 1) {
            clearInterval(timer);
            setDisableResend(false);
            setCountdown(15);
            setMessage(null);
            return 15; 
          }
          return prevCount - 1;
        });
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [disableResend]);

  const handleReturnToLogin = () => {
    navigate('/login')
  }

  const handleResendEmail = async () => {
    setDisableResend(true);

    try {
      const response = await fetch(`${dev_baseUrl}/Account/resendVerificationEmail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          firstName,
          lastName,
          email,
          password
        })
      });

      const data = await response.json();

      if (response.ok && !data.isError) {
        setMessage(data.result); // Display response message
      } else {
        console.error("Error:", data.message); // Handle error case
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  if (!email) {
    return (
      <Box textAlign="center" mt={4}>
        <Typography variant="h6">Email not found</Typography>
        <Typography>Please verify your email from the registration page.</Typography>
      </Box>
    );
  }

  const LinkStyled = styled(Link)(({ theme }) => ({
    textDecoration: 'underlined',
    color: `${theme.palette.primary.main} !important`,
    textTransform: 'none',
    pointerEvents: disableResend ? 'none' : 'auto'
  }))
  
  const Card = styled(MuiCard)(({ theme }) => ({
    [theme.breakpoints.up('sm')]: { width: '25rem' }
  }))

  return (
    <BlankLayout>
      <Box className='content-center'>
        <AuthIllustrationV1Wrapper>
          <Card>
            <CardContent sx={{ p: theme => `${theme.spacing(10.5, 8, 8)} !important` }}>
              {message && (
                <Box mb={2} textAlign="center">
                  <Typography variant="h6" color="green">{message}</Typography>
                </Box>
              )}
              <Box sx={{ mb: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img height='75' alt='logo' src='/images/Logo2.svg' />
              </Box>
              <Box sx={{ mb: 4, textAlign: 'center', display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography variant='h4' sx={{ mb: 1.5 }}>
                  Verification in Progress
                </Typography>
                <Typography sx={{ color: 'text.secondary' }}>
                  Open the email we sent to:
                </Typography>
                <Typography fontWeight='bold'>
                  {email}
                </Typography>
                <Typography sx={{ color: 'text.secondary' }}>
                  *If email can’t be found, check your Spam Folder
                </Typography>
              </Box>
              <Box sx={{ textAlign: 'center' }}>
                <Typography sx={{ color: 'text.secondary' }}>Still don’t see it?</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', mt: 1 }}>
                <Typography 
                    component={LinkStyled} 
                    sx={{ ml: 1 }}
                    onClick={e => { 
                      e.preventDefault(); 
                      handleResendEmail(); 
                    }} 
                    disabled={disableResend}
                  >
                    {disableResend ? `Resend Email (${countdown})` : 'Resend Email'}
                  </Typography>
                  <Typography onClick={handleReturnToLogin} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <LinkStyled>
                      <span>  Return to Login</span>
                    </LinkStyled>
                  </Typography>
              </Box>
            </CardContent>
          </Card>
        </AuthIllustrationV1Wrapper>
      </Box>
    </BlankLayout>
  );
};

export default VerifyEmail;